export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function loadScript(
  src: string,
  position: HTMLElement | null,
  id: string
) {
  if (!position) {
    return;
  }

  const script = document.createElement("script");
  script.setAttribute("async", "");
  script.setAttribute("id", id);
  script.src = src;
  position.appendChild(script);
}

/**
 * Safe json parse
 * @param objString
 * @returns any
 */
export function safeJsonParse(objString: any): any {
  try {
    if (objString instanceof Object || objString instanceof Array) {
      return objString;
    }
    return JSON.parse(objString || null);
  } catch (error) {
    return null;
  }
}

/**
 * Safely handles circular references
 */
export function safeStringify(obj: any, indent: number = 2): any {
  let cache: any[] = [];
  const retVal = JSON.stringify(
    obj,
    (key, value) =>
      typeof value === "object" && value !== null
        ? cache.includes(value)
          ? undefined // Duplicate reference found, discard key
          : cache.push(value) && value // Store value in our collection
        : value,
    indent
  );
  return retVal;
}

export function extractTranslated(value: string | any, language: string) {
  if (typeof value === "string") {
    const parsedValue = safeJsonParse(value);
    if (parsedValue != null) {
      return parsedValue[language];
    }
  }

  if (typeof value === "object") {
    return value[language];
  }

  return value;
}

export function checkEmail(value: string) {
  // https://emailregex.com
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return emailRegex.test(value);
}
